import React, { useState } from "react";
// import JS files

// import others files
import useFetch from "../../context/useFetch";
import { useNavigate } from "react-router-dom";

const SpecialNews = (props) => {
  const navigate = useNavigate();
  const [newsList, setNewsList] = useState([]);
  const getSpecialListApi = useFetch({
    method: "get",
    url: "News_Service/get_special_news",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsList(res);
    },
  });
  return (
    <>
      {newsList.map((item, index) => {
        return (
          <div
            className="my-4 md:my-0 bg-mygrays-100 rounded-lg md:p-4 flex flex-col md:flex-row items-center cursor-pointer text-hover-container"
            onClick={() => navigate(`/news-content/${item.id}`)}
          >
            <img
              src={item.news_detail[0].cover}
              className="rounded-t-md md:rounded-md w-full md:w-32"
            />
            <div className="md:mr-4 mt-2 md:mt-0 p-4 md:p-0">
              <span className=" block text-xs md:text-xs font-bold leading-7 text-myblacks-200">
                {item.news_detail[0].sub_header}
              </span>
              <span className="mt-2 block text-sm font-bold leading-7 text-myblacks-400 text-hover">
                {item.news_detail[0].header}
              </span>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default SpecialNews;
